module.exports = __webpack_public_path__ + "static/media/Huis-4-1.35b19fb5.jpg";